import { render, staticRenderFns } from "./Cancelled.vue?vue&type=template&id=54ca755f"
import script from "./Cancelled.vue?vue&type=script&lang=js"
export * from "./Cancelled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports